import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { TextField, makeStyles } from "@material-ui/core";
import { selectEmail, set } from "./emailSlice";

import { selectLanguage } from "../language/languageSlice";
import { setContent, setLevel, setOpen } from "../snackAlert/snackAlertSlice";
const useStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      margin: theme.spacing(1),
      width: "100%",
      "&:hover": {
        boxShadow: "0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23)",
      },
      transition: "box-shadow 0.75s",
    },
  },
}));

export function Email() {
  const classes = useStyles();
  const emailValue = useSelector(selectEmail);
  const language = useSelector(selectLanguage);
  const dispatch = useDispatch();
  // const [incrementAmount, setIncrementAmount] = useState("2");

  return (
    <form className={classes.root} noValidate autoComplete="off">
      <TextField
        type="email"
        required
        id="input-email"
        label={
          language !== undefined
            ? language === "TH"
              ? "อีเมล์"
              : "E-Mail"
            : "E-Mail"
        }
        placeholder={
          language !== undefined
            ? language === "TH"
              ? "อีเมล์ แอดเดรส"
              : "E-Mail Address"
            : "E-Mail Address"
        }
        variant="outlined"
        value={emailValue}
        color="secondary"
        multiline
        onChange={(e) => {
          if (e.target.value.length <= 100) {
            dispatch(set(e.target.value));
          }
        }}
        onBlur={(e) => {
          //console.log("on Blur");
          if (
            /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
              e.target.value
            ) === false
          ) {
            //console.log("not email");
            dispatch(setOpen(true));
            dispatch(setContent("Email format incorrect!!"));
            dispatch(setLevel("error"));
          }
        }}
      />{" "}
    </form>
  );
}
